import { Modal } from 'view-design'

const useI18n= true
/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
const objEqual = (obj1, obj2) => {
    const keysArr1 = Object.keys(obj1)
    const keysArr2 = Object.keys(obj2)
    if (keysArr1.length !== keysArr2.length) return false
    else if (keysArr1.length === 0 && keysArr2.length === 0) return true
    /* eslint-disable-next-line */
    else return !keysArr1.some(key => obj1[key] != obj2[key])
}
/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
 export const getHomeRoute = (routers, homeName = '首页') => {
    let i = -1
    let len = routers.length
    let homeRoute = {}
    while (++i < len) {
      let item = routers[i]
      if (item.children && item.children.length) {
        let res = getHomeRoute(item.children, homeName)
        if (res.name) return res
      } else {
        if (item.name === homeName) homeRoute = item
      }
    }
    return homeRoute
}  
export const showTitle = (item, vm) => {
    let {  __titleIsFunction__ } = item.meta
    let title=item.name
    if (!title) return
    if (useI18n) {
      if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, (m, str) => str.replace(/{{([\s\S]*)}}/, (m, _) => _.trim()))
      else if (__titleIsFunction__) title = item.meta.title
      else title = item.name
    } else title = (item.meta && item.meta.title) || item.name
    return title
}
/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
 export const routeEqual = (route1, route2) => {
    const params1 = route1.params || {}
    const params2 = route2.params || {}
    const query1 = route1.query || {}
    const query2 = route2.query || {}
    // return (route1.name === route2.name)
    // 取消判断传参路由判断
    return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}
export const beforeClose = {
    before_close_normal: (resolve) => {
        Modal.confirm({
        title: '确定要关闭这一页吗',
        onOk: () => {
            resolve(true)
        },
        onCancel: () => {
            resolve(false)
        }
        })
    }
}
/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
export const getRouteTitleHandled = (route) => {
    let router = { ...route }
    let meta = { ...route.meta }
    let title = ''
    if (meta.title) {
      if (typeof meta.title === 'function') {
        meta.__titleIsFunction__ = true
        title = meta.title(router)
      } else title = meta.title
    }
    meta.title = title
    router.meta = meta
    return router
}
/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
 export const getNextRoute = (list, route) => {
   console.log(list,route)
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}
/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
 export const doCustomTimes = (times, callback) => {
    let i = -1
    while (++i < times) {
      callback(i)
    }
  }
/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
 export const routeHasExist = (tagNavList, routeItem) => {
    let len = tagNavList.length
    let res = false
    doCustomTimes(len, (index) => {
      if (routeEqual(tagNavList[index], routeItem)) res = true
    })
    return res
}
/**
 * @description 本地存储和获取标签导航列表
 */
 export const setTagNavListInLocalstorage = list => {
    localStorage.tagNaveList = JSON.stringify(list)
}
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
 export const getTagNavListFromLocalstorage = () => {
    const list = localStorage.tagNaveList
    return list ? JSON.parse(list) : []
}
/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
 export const getNewTagList = (list, newRoute) => {
    const { name, path, meta } = newRoute
    let newList = [...list]
    if (newList.findIndex(item => item.name === name) >= 0) return newList
    else newList.push({ name, path, meta })
    return newList
}
/**
 * @param {*} object 克隆对象
 * @description 对象克隆
 */
export const deepClone = obj=>{
  if (typeof obj !== 'object') {
    return obj;
  } else {
      var newobj = obj.constructor === Array ? [] : {};
      for (var i in obj) {
          // eslint-disable-next-line valid-typeof
          newobj[i] = obj[i]!=null&&typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]; 
      }
      return newobj;
  }
}
/**
 * @description OosUploadFlag状态码转义
 */
export const oosState = {
  0:'未压缩',
  100:'已压缩待上云',
  159:'已压缩待上云',
  160:'上传至对象存储失败',
  161:'无影像',
  162:'影像文件未找到',
  163:'影像文件数量不匹配',
  164:'存储空间不足',
  165:'压缩包异常',
  200:'已压缩',
  300:'已解压',
  301:'影像已下载待解压',
  302:'影像已下载待解压',
}